import * as React from "react";
import { Box } from "@material-ui/core";


export default function TimeRangeField({ fromTime, toTime, onTimeChange }) {

  const [initialTime, setInitialTime] = React.useState({
     fromTime,
    toTime
  });

  const handleTimeChange = (event) => {
    const { name, value } = event.target;
    setInitialTime((prevTime) => ({
      ...prevTime,
      [name]: value,
    }));


    onTimeChange({ fromTime: initialTime.fromTime, toTime: initialTime.toTime });
  };

  return (
    <Box
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "2rem",
      }}
    >
      <input
        type="time"
        id="fromTime"
        name="fromTime"
        value={initialTime.fromTime}
        onChange={handleTimeChange}
        required
        style={{
          padding: "10px",
          border: "1px solid #D8D8D8",
        }}
      />

      <input
        type="time"
        id="toTime"
        name="toTime"
        value={initialTime.toTime}
        onChange={handleTimeChange}
        required
        style={{
          padding: "10px",
          border: "1px solid #D8D8D8",
        }}
      />
    </Box>
  );
}
